import * as React from "react";

const SendNowPopover = (
  <div className="sendnow-popover">
    <p>
      This will send a copy of the report <br />
      for the latest complete reporting period.
    </p>
  </div>
);

export default SendNowPopover;



// WEBPACK FOOTER //
// ./client/modules/Report/components/ViewReports/SendNowPopover.tsx